module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-gray-f1ecf8.svg";